import { handleActions } from 'redux-actions';
import { initState } from '../../../redux/models';
import * as actionType from './actionType';

export default handleActions(
  {
    //更新信息
    [actionType.PURCHASEORDERMONITORINGMANAGEMENT_UPDATE]: (state, { data }) => {
      const newState = { ...state, ...data };
      return newState;
    },
    [actionType.PURCHASEORDERMONITORINGMANAGEMENT_FILE]: state => {
      const newState = { ...state, iconLoading: false, tableLoading: false, buttonLoading: false };
      return newState;
    },
  },
  initState,
);
